// Story 18.12 review (ADO-3685): the cart's RBP missed-products widget is gated behind C6, a
// bmad-correct-course against the signed-off Cart & Order Capture 2.0 scope that has not been run.
// Until it is run or waived, the widget must not mount on a cart outside dev, so it sits behind this
// build flag, off by default. On, the cart reads and shows the widget (`useMissedProducts`).
//
// Vite bakes `VITE_*` values in at build time. The deployed web image gets it as a build arg from
// the committed per-env map `tools/deploy/rbp-missed-products.mjs` (on in dev, off in stg and prod);
// locally it is set in `apps/web/.env`. This flag is deleted once C6 clears the widget for the
// signed-off scope. It mirrors the real-prices flag's shape (`pricing/realPrices.ts`).

/** True only when `VITE_RBP_MISSED_PRODUCTS_ENABLED` is exactly `'true'`. Read on every call, not
 *  once at import, so a spec can stub it per test. */
export function rbpMissedProductsEnabled(): boolean {
  return import.meta.env.VITE_RBP_MISSED_PRODUCTS_ENABLED === 'true';
}
